import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { isSafeReturnTo } from '../lib/return_to';

export function SignInConsume() {
  const [params] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    const token = params.get('token');
    if (!token) {
      navigate('/sign-in', { replace: true });
      return;
    }

    // Honour the same-origin callbackURL the magic link was issued with (the
    // /book wizard uses it to resume a draft); anything else lands on /account.
    const callbackURL = params.get('callbackURL');
    const destination = isSafeReturnTo(callbackURL) ? callbackURL : '/account';

    const verifyUrl = `/api/customer-auth/magic-link/verify?${params.toString()}`;
    fetch(verifyUrl, { credentials: 'include' })
      .then((r) => {
        if (r.ok || r.redirected) {
          navigate(destination, { replace: true });
        } else {
          navigate('/sign-in', { replace: true, state: { error: 'invalid_link' } });
        }
      })
      .catch(() => navigate('/sign-in', { replace: true, state: { error: 'network' } }));
  }, [navigate, params]);

  return (
    <main
      style={{
        minHeight: '100dvh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <span style={{ color: 'var(--muted-foreground, #6b6b6b)' }}>Signing you in…</span>
    </main>
  );
}
